
export default {
    Shipper: {},
    Shippers: [],
    TotalInfo: {
        totalRecord: 0,
        pageSize: 20,
        pageIndex: 1
    },
}